module.exports = fox._r("images/right.jpg", __webpack_public_path__ + "_/_/_/affiliate/images/right.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/images/right.jpg
// module id = 188
// module chunks = 4